var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRuleIcon = function SvgRuleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8744_14449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.91422 4.58579C8.69527 5.36684 8.69527 6.63317 7.91422 7.41422C7.13317 8.19527 5.86684 8.19527 5.08579 7.41422C4.30474 6.63317 4.30474 5.36684 5.08579 4.58579C5.86684 3.80474 7.13317 3.80474 7.91422 4.58579Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.234 18H8.627C7.176 18 6 16.657 6 15.001V14.998C6 13.342 7.176 11.999 8.627 11.999H15.372C16.823 11.999 17.999 10.656 17.999 9C18 7.341 16.822 5.998 15.37 6L11.25 6.005",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.34 20.1839L19.229 18.4749C19.59 18.2609 19.59 17.7379 19.229 17.5249L16.34 15.8159C15.969 15.5959 15.5 15.8639 15.5 16.2949V19.7049C15.5 20.1359 15.969 20.4039 16.34 20.1839Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8744_14449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgRuleIcon as ReactComponent };
export default __webpack_public_path__ + "rule-icon.svg";